import { createTotalsTextFromMultiplePricingTypes } from "~/design-system/components/matter-editor/pricing-text-creators";
import { ParentMatterPartsFragment } from "~/gql/graphql";

type PricingResult = ReturnType<typeof createTotalsTextFromMultiplePricingTypes> & {
  title: string;
};
export const groupLineTotalByMatters = (
  matters: ParentMatterPartsFragment[],
  excludeTax: boolean,
  taxLevelPercent: number,
  administrationCharge: number,
  currencySymbol: string
) => {
  return matters.reduce((acc, matter) => {
    const input = mapMatterToTotalsInput(matter, excludeTax, taxLevelPercent, administrationCharge);
    const result = createTotalsTextFromMultiplePricingTypes([input], currencySymbol);
    acc.set(matter.id, { ...result, title: matter.title });
    return acc;
  }, new Map<number, PricingResult>());
};

const mapMatterToTotalsInput = (
  x: ParentMatterPartsFragment,
  excludeTax: boolean,
  taxLevelPercent: number,
  administrationCharge: number
) => {
  return {
    pricingSummary: x.priceOptions!,
    phases: x.phases,
    disbursements: x.disbursements,
    uplifts: x.uplifts,
    discounts: x.discounts,
    technologyCharges: x.technologyCharges,
    matterWork: x.work,
    pricingLevel: x.pricingLevel,
    pricingType: x.pricingType,
    excludeTax,
    taxLevelPercent,
    administrationCharge,
    waiveAdminCharge: x.waiveAdminCharge ?? false,
  };
};
